import { createFeatureContext } from 'src/libs/FeatureConfig';

export const { FeatureConfigProvider, useFeatureConfig } = createFeatureContext(
  [
    {
      name: 'location-filter',
      gradualRolloutConfig: {},
    },
    {
      name: 'srn-top',
      gradualRolloutConfig: {
        'employer-seek-au': ['0', '2', '4', '6', '8'],
      },
    },
    {
      name: 'srn-bottom',
      gradualRolloutConfig: {
        'employer-seek-au': ['1', '3', '5', '7', '9'],
      },
    },
  ],
);
